import { css, type Theme } from "@emotion/react";
export const container = (theme: Theme) =>
  css({
    padding: "1.5rem",
    backgroundColor: theme.system.backgroundMuted,
    borderRadius: "0.5rem",
    maxHeight: "calc(100vh - 8rem)",
    overflowY: "auto",
  });
